import { Tooltip, IconButton } from '@material-ui/core';
import i18next from 'i18next';
import React from 'react';
import { tooltipEnterDelay } from 'src/config';
import ReplayIcon from '@material-ui/icons/Replay';
import { API_URLS } from 'src/common/ApiService';
import { useRequest } from 'src/common/useRequestHook';
import { RequestMethod } from 'src/utils/request';
import { Order } from 'src/models/Order';
import { useDispatch } from 'react-redux';
import { loadOrderSuccess } from '../OrderActions';
import { showNotification } from 'src/common/notifications/NotificationsActions';
import { NotificationVariant } from 'src/models/Notification';
import { useConfirmationDialog } from 'src/common/confirmationDialog/useConfirmationDialog';

interface Props {
    isShown: boolean;
    className: string;
    orderId?: string;
}

export const ResetOrderButton: React.FC<Props> = ({
    isShown,
    className,
    orderId
}) => {
    const dispatch = useDispatch();
    const confirm = useConfirmationDialog();
    const [resetOrder, { inProgress }] = useRequest<Order>(
        RequestMethod.POST,
        API_URLS.resetOrder
    );

    if (!isShown) {
        return null;
    }

    const handleResetOrder = async () => {
        if (!(await confirm(i18next.t('order.resetOrderConfirmation')))) {
            return;
        }
        const updatedOrder = await resetOrder({ orderId });

        dispatch(loadOrderSuccess(updatedOrder));
        dispatch(
            showNotification({
                id: `reset_order_${Date.now()}`,
                variant: NotificationVariant.Success,
                text: i18next.t('order.resetOrderSuccess')
            })
        );
    };

    return (
        <Tooltip
            title={i18next.t('order.resetOrder')}
            enterDelay={tooltipEnterDelay}
        >
            <div className={className}>
                <IconButton
                    color="inherit"
                    onClick={handleResetOrder}
                    disabled={inProgress}
                >
                    <ReplayIcon />
                </IconButton>
            </div>
        </Tooltip>
    );
};
